import * as React from "react";
import {DocumentManager} from "../Manager/PDFManager/DocumentManager";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faUpload} from "@fortawesome/free-solid-svg-icons/faUpload";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import './SelectAPDF.css';
import {ConfirmationDialog} from "shared/controls/Dialogs/premade/ConfirmationDialog/ConfirmationDialog";
import {DeleteDialog} from "shared/controls/Dialogs/premade/DeleteDialog";
import {PDFDocument} from "PDFLib/api";
import {ToastService} from "shared/core/services/ToastService";
import {LicenseRequired} from "../../PDFList/LicenseRequired";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {PDFRef} from "PDFLib/core";

export class SelectAPDF extends React.Component<SelectAPDFProps, SelectAPDFState> {
    static defaultProps: Partial<SelectAPDFProps> = {};
    public FileUpload:any;
    public FileUploadMerger:any;
    constructor(props: SelectAPDFProps) {
        super(props);
        this.state = {};
        this.FileUploadRendered=this.FileUploadRendered.bind(this);
        this.FileUploadRenderedToMerge=this.FileUploadRenderedToMerge.bind(this);
    }

    FileUploadRendered(node){
        this.FileUpload=node;
    }

    FileUploadRenderedToMerge(node){
        this.FileUploadMerger=node;
    }


    public render() {
        return (
            <div style={{marginBottom:10}}>
                <label style={{fontWeight:'bold',fontSize:16}}>PDF File</label>
                <input className={'fileUploader'} type={'file'} style={{display:'none'}} ref={this.FileUploadRendered} onChange={e=>this.ReadPDF(e)} accept={'application/pdf'}/>
                <input className={'pdfMerger'} type={'file'} style={{display:'none'}} ref={this.FileUploadRenderedToMerge} onChange={e=>this.ReadPDFToMerge(e)} accept={'application/pdf'}/>
                <div style={{marginTop:5}}>
                    {this.GetControl()}
                </div>
            </div>
        )
    }

    private GetControl() {
        if(this.props.Manager.Options.PDFURL=='')
        {
            return(
                    <button onClick={()=>this.UploadFile()} className={'rnbtn rnbtn-primary'}><FontAwesomeIcon icon={faUpload}/> Click here to upload a pdf</button>
            )
        }else{
            return(
                <div>
                    <div style={{display:'flex',alignItems:'center'}}>
                        <label>{this.props.Manager.Options.PDFName}</label>
                        <FontAwesomeIcon icon={faUpload} className={'trash'} style={{marginLeft:5}} title={'Reupload pdf'} onClick={()=>this.Remove()}/>

                    </div>
                    <div style={{marginTop:10}}>
                        <a href={'#'} onClick={e=>this.Merge(e)}>Merge with another pdf</a>
                    </div>

                </div>
            )
        }
    }

    private UploadFile() {
        this.FileUpload.click();
    }



    private ReadPDF(e: React.ChangeEvent<HTMLInputElement>) {
        if(e.target.value=='') {
            this.props.Manager.SetPDFFileName('');
            this.props.Manager.SetPDFFileURL('');
            return;
        }

        this.props.Manager.File=e.target.files[0];
        this.props.Manager.FileList=e.target.files;
        this.props.Manager.SetPDFFileName(e.target.files[0].name);
        this.props.Manager.SetPDFFileURL('loaded');
        this.forceUpdate();
        let file=e.target;
        return new Promise(resolve => {
            var fileReader = new FileReader();
            fileReader.onload = async (reader:any)=> {
                file.value=null;
                var typedarray = new Uint8Array(reader.target.result);
                this.props.Manager.InitializeDocument(typedarray);
            };

            fileReader.readAsArrayBuffer(e.target.files[0]);

        });


    }

    private ReadPDFToMerge(e: React.ChangeEvent<HTMLInputElement>) {
        if(e.target.value=='') {
            this.props.Manager.SetPDFFileName('');
            this.props.Manager.SetPDFFileURL('');
            return;
        }

        this.forceUpdate();
        return new Promise(resolve => {
            var fileReader = new FileReader();
            fileReader.onload = async (reader:any)=> {
                var typedarray = new Uint8Array(reader.target.result);
                let documentToMerge = await PDFDocument.load(typedarray);

                if(this.props.Manager.Document!=null&&documentToMerge!=null)
                {
                    let pageIndex=[];
                    for(let i=0;i<documentToMerge.getPageCount();i++)
                        pageIndex.push(i);

                    let copiedPages=await this.props.Manager.Document.copyPages(documentToMerge,pageIndex);
                    for(let pageToCopy of copiedPages)
                    {
                        this.props.Manager.Document.addPage(pageToCopy);
                        let annots=pageToCopy.node.Annots();
                        if(annots!=null) {
                            for (let i = 0; i < annots.size(); i++) {
                                let currentAnnot = annots.get(i);
                                if (currentAnnot instanceof PDFRef) {
                                    this.props.Manager.Document.getForm().acroForm.addField(currentAnnot);
                                }
                            }
                        }
                    }
                    await this.props.Manager.RefreshDocument();
                    ToastService.SendSuccess('PDF Merged Successfully')
                }else{
                    ToastService.SendErrorMessage('Sorry the document can not be merged');
                }




            };

            fileReader.readAsArrayBuffer(e.target.files[0]);

        });


    }

    private async Remove() {
        if( await DeleteDialog.Show('','Are you sure?',null,<p>Do you want to reupload the pdf?</p>))
        {
            this.FileUpload.click();
        }
    }

    private Merge(e: React.MouseEvent<HTMLAnchorElement>) {
        e.preventDefault();
        if(!rnImporterVar.IsPR)
        {
            Dialog.Show(<LicenseRequired Message={'Sorry this feature is only available in the full version'} URL={rnImporterVar.PurchaseURL}/>);
            return;
        }
        this.FileUploadMerger.click();
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface SelectAPDFProps {
    Manager:DocumentManager;
}

interface SelectAPDFState {

}

//#endregion "My Region"